import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {ITransportCompany} from "../../../../../../../utils/interfaces/my_documents/ITransportCompany";


const useApiGetTransportCompany = (pk: number | undefined): UseQueryResult<ITransportCompany, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<ITransportCompany> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/transport_company/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetTransportCompany", pk],
        enabled: !!pk,
        queryFn: () => doGet(selectedCompany?.company_token, pk)
    })

};

export default useApiGetTransportCompany